export const TagTypes = {
  notification: 'notification',
  growthPlan: 'growthPlan',
  growthPlanSessionTimes: 'growthPlanSessionTimes',
  supplier: 'supplier',
  suppliers: 'suppliers',
  sourcingRequests: 'sourcingRequests',
  sourcingRequestsMatches: 'sourcingRequestsMatches',
  opportunity: 'opportunity',
  opportunities: 'opportunities',
  supplierSpotlight: 'supplierSpotlight',
  supplierAvatar: 'supplierAvatar',
  supplierAvatars: 'supplierAvatars',
  supplierActivity: 'supplierActivity',
  vettingRequests: 'vettingRequests',
  vettingTemplates: 'vettingTemplates',
  vettingRequestAssessment: 'vettingRequestAssessment',
  supplierRequests: 'supplierRequests',
  supplierRequestsImported: 'supplierRequestsImported',
  supplierRequestMatches: 'supplierRequestMatches',
  supplierRequestMatchCandidate: 'supplierRequestMatchCandidate',
  supplierRequestMatchMessage: 'supplierRequestMatchMessage',
  supplierRequestMatchQuestion: 'supplierRequestMatchQuestion',
  capitalRequests: 'capitalRequests',
  capitalRequestMatches: 'capitalRequestMatches',
  user: 'user',
  users: 'users',
  assessments: 'assessments',
  assessment: 'assessment',
  assessmentSubmission: 'assessmentSubmission',
  assessmentRecord: 'assessmentRecord',
  assessmentScore: 'assessmentScore',
  avatar: 'avatar',
  org: 'org',
  supportTickets: 'supportTickets',
  feedbackSubmissions: 'feedbackSubmissions',
  registrations: 'registrations',
  registrationCodes: 'registrationCodes',
  platformMetrics: 'platformMetrics',
  enterpriseCustomers: 'enterpriseCustomers',
};
